import * as types from './actionTypes';
import {apiRequest, apiPost, apiDelete, apiRequestAnonymous} from '../utils/request';
import {toastr} from 'react-redux-toastr';
import {allowUserWithRoles, EMPTY_GUID, ROLE_Admin, ROLE_ClientUser, ROLE_LocationUser, ROLE_OfficeUser, ROLE_SuperUser} from '../constants';
import {loadDrivers} from './driverActions';
import { getErrorMessage, requestHasError } from '../utils/lib';

export function loadUsersSuccess(users){
  return {type: types.LOAD_USERS_SUCCESS, users};
}

export function saveUserSuccess(user){
  return {type: types.SAVE_USER_SUCCESS, user};
}

export function deleteUserSuccess(user){
  return {type: types.DELETE_USER_SUCCESS, user};
}

export function saveUserError(saveError){
  return {type: types.SAVE_USER_ERROR, saveError};
}

export function loadUsers() {
  return function (dispatch, getState) {
    let account = getState().account;

    return apiRequest(`/api/users`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching users, error: ${x.error ? x.error : x.data.Message}`);
          dispatch(loadUsersSuccess({loaded: true, items: []}));
        } else {
          if(allowUserWithRoles(account, [ROLE_Admin, ROLE_SuperUser, ROLE_OfficeUser, ROLE_ClientUser, ROLE_LocationUser])) {
            let ars = x.data.filter(x => x.hasAuthorisationRequest);
            if (ars.length > 0) {
              toastr.warning(`There are ${ars.length} user(s) who have outstanding authorisation requests`);
            }
          }
          dispatch(loadUsersSuccess({loaded: true, items: Array.from(x.data)}));
        }
        return x;
      });
  };
}



export function saveUser(user){
  return function (dispatch, getState) {
    let account = getState().account;
    toastr.success('Saving user');
    return apiPost(`/api/users/${user.userId}`, user)
      .then(x => {
        if (requestHasError({x})) {
          let errorMessage = getErrorMessage({x});
          dispatch(saveUserError({error: errorMessage, user}));
          toastr.error(`Error: ${errorMessage}`);
        } else {
          dispatch(saveUserSuccess(x.data));
          if(account.user.hasRole(ROLE_SuperUser))
          {
            dispatch(loadDrivers());
          }
        }
        return x;
      });
  };
}

// Change Password

export function updatePassword({payLoad}){
  return function (dispatch, getState) {
    toastr.success('Updating password');
    return apiPost(`/api/users/resetpassword`, payLoad)
      .then(x => {
        if (requestHasError({x})) {
          let errorMessage = getErrorMessage({x});
          toastr.error(`Error while updating password, error: ${errorMessage}`);
        }
        return x;
      });
  };
}



export function unlockUser(user){
  return function (dispatch) {
    toastr.success('Unlocking user');
    return apiPost(`/api/users/${user.userId}/unlock`, user)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while unlocking user, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          dispatch(saveUserSuccess(x.data));
        }
      });
  };
}

export function deleteUser(user, syncToB2C = true){
  return function (dispatch) {
    toastr.success('Deleting user');
    return apiDelete(`/api/users/${user.userId}?syncToB2C=${syncToB2C}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while deleting user, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          dispatch(deleteUserSuccess(user));
          dispatch(loadDrivers());
        }
        return x;
      });
  };
}

// Get Resetpassword details
export function getResetPasswordDetail({token}) {
  return function () {
    return apiRequestAnonymous(`/api/users/forgotpassword/verify?token=${token}`)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Error: ${getErrorMessage({x})}`);
        }
        return x;
      });
  };
}

// Verify Email and get reset password link
export function verifyEmailAddress({payLoad}){
  return function () {
    return apiRequestAnonymous(`/api/users/forgotpassword`,"POST",true, payLoad)
      .then(x => {
        if (requestHasError({x})) {
          let errorMessage = getErrorMessage({x});
          toastr.error(`Error: ${errorMessage}`);
        }
        return x;
      });
  };
}

// Reset Password
export function resetPassword({payLoad}){
  return function () {
    return apiRequestAnonymous(`/api/users/forgotpassword/update`,"POST",true, payLoad)
      .then(x => {
        if (requestHasError({x})) {
          let errorMessage = getErrorMessage({x});
          toastr.error(`Error: ${errorMessage}`);
        }
        return x;
      });
  };
}

// Send invite to external users
export function inviteExternalUsers({payLoad}){
  return function () {
    return apiPost(`/api/invites/externaluser`, payLoad)
      .then(x => {
        if (requestHasError({x})) {
          let errorMessage = getErrorMessage({x});
          toastr.error(`Error: ${errorMessage}`);
        }
        return x;
      });
  };
}